import { useQuery } from "@apollo/client/react";
import { Badge, BadgeText } from "@repo/components/src/ui/badge";
import { Button, ButtonIcon } from "@repo/components/src/ui/button";
import { GetProductSelectionDocument } from "@repo/graphql/documents/product/query.generated";
import { X } from "lucide-react-native";
import React, { useCallback } from "react";

type Props = {
  productId: string;
  quantity: number;
  index: number;
  onRemove: (index: number) => void;
};

const ProductBadge = React.memo((props: Props) => {
  const { data } = useQuery(GetProductSelectionDocument, {
    variables: { id: props.productId },
  });
  const product = data?.product.get;
  const onPressHandler = useCallback(() => {
    props.onRemove(props.index);
  }, [props]);
  return (
    <Badge action="muted" variant="outline" size="md">
      <BadgeText>{`${props.quantity} x ${product?.name}`}</BadgeText>
      <Button
        variant="link"
        size="none"
        className="ml-1"
        onPress={onPressHandler}
      >
        <ButtonIcon size="sm" as={X} />
      </Button>
    </Badge>
  );
});

ProductBadge.displayName = "ProductBadge";

export default ProductBadge;
